import {
  isArchiveStepType,
  isEditStepType,
  isPublishStepType,
  isReviewPhaseStepType,
  isSignatureStepType,
  normalizeDocumentStatus,
  type OfficialDocumentStatus,
} from './workflowConstants';

export function workflowTemplateHasSignaturePhase(
  steps: { type: string }[] | null | undefined
): boolean {
  if (!steps?.length) return false;
  return steps.some(s => isSignatureStepType(s.type));
}

export function workflowHasSignaturePhaseInDefinition(
  templateSteps: { type: string }[] | null | undefined
): boolean {
  return workflowTemplateHasSignaturePhase(templateSteps);
}

export function workflowHasSignaturePhaseInInstances(
  instanceSteps: { definitionType?: string | null }[] | null | undefined
): boolean {
  if (!instanceSteps?.length) return false;
  return instanceSteps.some(s => isSignatureStepType(s.definitionType));
}

export function workflowHasIntegratedSignaturePhase(
  templateSteps: { type: string }[] | null | undefined,
  instanceSteps: { definitionType?: string | null }[] | null | undefined
): boolean {
  return (
    workflowHasSignaturePhaseInDefinition(templateSteps) ||
    workflowHasSignaturePhaseInInstances(instanceSteps)
  );
}

export function shouldApplyStandaloneSignatureRules(params: {
  hasDocumentWorkflow: boolean;
  templateSteps?: { type: string }[] | null;
  instanceSteps?: { definitionType?: string | null }[] | null;
}): boolean {
  if (!params.hasDocumentWorkflow) {
    return true;
  }

  return !workflowHasIntegratedSignaturePhase(params.templateSteps, params.instanceSteps);
}

export function mapWorkflowDefinitionTypeToUiStatus(
  type: string | null | undefined,
  persistedDocumentStatus: string | null | undefined
): OfficialDocumentStatus | null {
  if (!type?.trim()) return null;
  const n = type.trim();
  const ps = normalizeDocumentStatus(persistedDocumentStatus) as string;

  if (isEditStepType(n)) return 'edit';
  if (isReviewPhaseStepType(n)) return 'review';
  if (isSignatureStepType(n)) return 'signature';
  if (isPublishStepType(n)) {
    if (ps === 'published') return 'published';
    return 'review';
  }
  if (isArchiveStepType(n)) {
    if (ps === 'archived') return 'archived';
    if (ps === 'published') return 'published';
    return 'published';
  }
  return null;
}

export function workflowTemplateHasReviewPhase(
  steps: { type: string }[] | null | undefined
): boolean {
  if (!steps?.length) return false;
  return steps.some(s => isReviewPhaseStepType(s.type));
}
